import React, { PropsWithChildren } from 'react'

type ModalContentContainerProps = PropsWithChildren<{}>

export const ModalContentContainer = ({
  children,
}: ModalContentContainerProps) => {
  return <div className='!py-4 !px-5 md:!px-10 md:!py-6'>{children}</div>
}
